import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { HelpCircle, MessageSquare, FileText, Shield } from 'lucide-react';

const HelpPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6 text-center">Help Center</h1>
        <p className="text-lg text-gray-600 mb-12 text-center">We're here to help you get the most out of Profind.ca</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link to="/faq">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardContent className="p-6 text-center">
                <HelpCircle className="h-12 w-12 text-orange-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">FAQ</h3>
                <p className="text-gray-600">Find answers to commonly asked questions</p>
              </CardContent>
            </Card>
          </Link>
          
          <Link to="/contact">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardContent className="p-6 text-center">
                <MessageSquare className="h-12 w-12 text-orange-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Contact Support</h3>
                <p className="text-gray-600">Get in touch with our support team</p>
              </CardContent>
            </Card>
          </Link>
          
          <Link to="/how-it-works">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardContent className="p-6 text-center">
                <FileText className="h-12 w-12 text-orange-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">How It Works</h3>
                <p className="text-gray-600">Learn how to use Profind.ca</p>
              </CardContent>
            </Card>
          </Link>
          
          <Link to="/trust-safety">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardContent className="p-6 text-center">
                <Shield className="h-12 w-12 text-orange-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Trust & Safety</h3>
                <p className="text-gray-600">Learn about our safety measures</p>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HelpPage;